import React, { useState,useEffect,useContext } from "react";
import Fade from "react-reveal/Fade";
import { Row, Col,Spinner } from "react-bootstrap";
import { FiArrowUpRight, FiArrowDownLeft,FiCheck } from "react-icons/fi";
import copy from "../../components/assets/copy.png";
import { Link } from "react-router-dom";
import { useSnackbar } from "notistack";
import axios from "axios";
import Cookies from "js-cookie";
import {UserContext} from "../../components/UserContext"

const url = "https://www.bitmasta.io/php/functioned.php"

const SellCheckOut = ({type,usd,amount,checked,totalAmount,walletAddress,barcode,banks}) => {
  const user = useContext(UserContext)
  const { enqueueSnackbar } = useSnackbar();
  const [proceed, setProceed] = useState(false);
  const [account, setAccount] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [loadingAcc, setLoadingAcc] = useState(false);
  const [copySuccess, setCopySuccess] = useState("");
  const [name, setName] = useState("");
  const [accName, setAccName] = useState("");
  const [referredDetails, setReferredDetails] = useState("");
  const [accNum, setAccNum] = useState("");

  useEffect(()=>{
    const fetchRef = async () => {
      let formData = new FormData();
      formData.append("referredCode",true)
      formData.append("Active_User",user.user)
      try{
     const res = await axios.post(url,formData)
    
        if(res.data.status === "Referred Code Found"){
          if(res.data.Data)
          setReferredDetails(res.data.Data[0])
        }
        else{
          
        }
      }
      catch(_er){
     console.log(_er)
      }
    }
    
    fetchRef()
  },[user.user])

  useEffect(()=>{
    let code = banks.filter(item=>item.name === name)
    if( accNum.length === 10 && code.length > 0){
    setLoadingAcc(true)
    axios.get(`https://api.paystack.co/bank/resolve?account_number=${accNum}&bank_code=${code[0].code}`,{
      headers: {
        Authorization: 'Bearer sk_test_d61838c019730ef4fb8fc4bbab6e8369d2ddf868'
      }
    }).then((res)=>{
      setLoadingAcc(false)
      setAccName(res.data.data.account_name)}).catch((_er)=>{
        setAccName("No account found")
        setLoadingAcc(false)
      })
    }
  },[accNum,banks,name])
  const copyToClipboard = () => {
    var textField = document.createElement('textarea')
    textField.innerText = walletAddress
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()
    setCopySuccess('Copied!');
    };
  const confirmation = (
    <Fade>
      <div className="d-flex my-3 justify-content-center flex-column align-items-center">
        <FiCheck size={42} />
        <p className="med my-2 blueText b7">Confirmation in Progress</p>
        <p className="mb-5">Your order will reflect on your account soon</p>
        <Link to="/dashboard" className="mail">Go back to home</Link>
      </div>
    </Fade>
  );
  const handleSell = () => {
    if(!name || !accName || !accNum)
    enqueueSnackbar("All fields are required", {
      variant: "error",
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    })
    else  if(accName === "No account found")
    enqueueSnackbar("Invalid account details", {
      variant: "error",
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    })
    else{
      let normalPrice = checked ? `${usd} NGN` : `${usd} USD`
      const formData = new FormData()
      formData.append("Trade_Type","Sell")
      if(referredDetails){
        formData.append("Code",referredDetails.code)
        formData.append("IsTransact",referredDetails.user_transact)
      }
      formData.append("Address",null)
      formData.append("Upload",false)
      formData.append("Active_User",Cookies.get("auth"))
      // formData.append("Currency",type)
      formData.append("Amount_In_Other",normalPrice)
      formData.append("Amount_In_Crypto",`${type} ${amount}`)
      formData.append("Bank_Name",name)
      formData.append("Account_Number",accNum)
      formData.append("Account_Name",accName)
       axios.post(url,formData).then(res=>{
        if(res.data.status === "Transaction Error"){
          enqueueSnackbar(res.data.message, {
            variant: "error",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right",
            },
          })
        }
        else if(res.data.status === "Transaction Successful"){
          setConfirm(true);
          enqueueSnackbar(res.data.message, {
            variant: "success",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right",
            },
          })
        }
      })
    }
  }
  function Account(setConfirm) {
    return (
      <Fade>
        <div>
          <div className="m-auto bts-settings-wrapper">
            <p className="med blueText b7">Your Bank details</p>
            <form action="">
              <Row>
                <Col md={12} className="position-relative">
                  <label className="smallText lightBlue b5 input-details">
                  Bank Name
                  </label>
                  {/* <input type="text"  /> */}
                  <select className="d-block border-black w-100 border-top-0 border-left-0 border-right-0 mb-3" value={name} onChange={e=>setName(e.target.value)}>
                  <option value="">Selet a bank</option>
                    { banks.map(bank=>
                      <option key={bank.name} value={bank.name}>{bank.name}</option>
                    )}
                  </select>
                </Col>
                
                <Col md={12} className="position-relative">
                  <label className="smallText lightBlue b5 input-details">
                    Account Number
                  </label>
                  <input type="number" value={accNum} onChange={e=>setAccNum(e.target.value)} maxLength={10}/>
                </Col>
               {loadingAcc && <Col md={12}>
                <Spinner size="sm" animation="border" variant="primary" />
                </Col>}
                <Col md={12} className="position-relative">
                  <label className="smallText lightBlue b5 input-details">
                  Account Name
                  </label>
                  <input type="text" value={accName} disabled onChange={e=>setAccName(e.target.value)} />
                </Col>
              </Row>
            </form>
          </div>
          <div className="py-2 buy-wrapper px-4">
            <button
              onClick={handleSell}
              className="w-100"
            >
              Proceed
            </button>
          </div>
        </div>
      </Fade>
    );
  }
  const SellCheck = (
    <Fade>
      <div className="m-auto bts-settings-wrapper">
        <p className="med blueText b7">Sell</p>
        <form action="">
          <Row className="my-3">
            <Col md={5}>
              <p>{type}</p>
              <p className=" smallText lightBlue b5 input-details">{amount}</p>
            </Col>
            <Col md={2} className="d-flex align-items-center">
              <FiArrowUpRight className="lightBlue" />
              <FiArrowDownLeft className="blueText" />
            </Col>
            <Col md={5}>
              <p>{checked?"NGN":"USD"}</p>
              <p className="smallText blueText b5 input-details">{usd}</p>
            </Col>
          </Row>

          <div className="justify-content-between py-2 my-3 px-2 border-rad bts-coin-rates d-flex whiteText">
            <span className="lightText">We'll pay you</span>
            <span className="blueText font-weight-bold">{totalAmount}</span>
          </div>
        </form>
      </div>
      <div className="py-2 buy-wrapper px-4">
        <button onClick={() => setProceed(true)} className="w-100">
          Proceed
        </button>
      </div>
    </Fade>
  );
  const nextCheckOut = (
    <Fade>
      <div className="bts-settings-wrapper">
        <p className="med blueText b7">
          Send {amount} {type} for <span className="lightBlue">{totalAmount}</span> to the
          address below
        </p>
        {document.queryCommandSupported('copy') &&
          <div className="blueText mb-2 font-weight-bold text-right">
            {copySuccess}
          </div>}
        <div className="d-flex w-100 align-items-center justify-content-center">
          <div className="mr-3 py-2 px-3 border-rad bts-coin-rates d-flex font-weight-bold blueText align-items-center">
         
            <p className="fs-14">{walletAddress}</p>
          </div>
          <div>
          <div className="buy-wrapper">
            <button onClick={copyToClipboard} className="m-0 p-2">
              <img src={copy} alt="" />
            </button>
          </div>
          </div>
        </div>
        <div className="d-flex mt-3 justify-content-center">
          <img src={barcode} width="100%" alt="" />
        </div>
      </div>
      <div className="py-2 buy-wrapper px-4">
      
        <button
          onClick={() => {
            setAccount(true);
            setProceed(false);
          }}
          className="w-100"
        >
          Proceed
        </button>
      </div>
    </Fade>
  );

  return (
    <>
      <Row className="mb-4">
        <Col md={2}></Col>
        <Col md={8}>
          {!proceed && !account && SellCheck}
          {proceed && nextCheckOut}
          {account && !confirm && Account(setConfirm)}
          {confirm && confirmation}
        </Col>
      </Row>
    </>
  );
};

export default SellCheckOut;
